import React, { FC } from 'react';
import { ReactComponent as Cashback } from '../../../assets/MainMenu/Cashback.svg';

export const CashbackIcon: FC = () => <Cashback />;
